export default __webpack_public_path__ + "media/components/InstructionButton/images/rule1-d821fce3c33e0dc39e46b3bf5edf5fbf.png";